import { ELSDropDownOption } from '@els/els-component-form-field-react';

export const ALL_OPTION: ELSDropDownOption = {
  value: 'ALL',
  name: '-All-'
};

export const zeroSeconds = '0 sec';
